export default __webpack_public_path__ + "static/media/fvc.cb69fb1b.png";